export const displayWrappedWithEllipsis = (text: string, maxChars: number) => {
    if (text.length > maxChars) {
        return text.substring(0, maxChars).trim() + '…'
    }
    return text
}
